type XmlObject = Record<string, unknown>;

const elementToValue = (element: Element): string | XmlObject => {
    const value: XmlObject = {};

    if (element.attributes.length > 0) {
        value.$ = Object.fromEntries(Array.from(element.attributes, attribute => [attribute.name, attribute.value]));
    }

    let text = "";

    for (const node of element.childNodes) {
        if (node.nodeType === Node.TEXT_NODE || node.nodeType === Node.CDATA_SECTION_NODE) {
            const nodeValue = node.nodeValue ?? "";
            if (nodeValue.trim() !== "") {
                text += nodeValue;
            }
            continue;
        }

        if (node.nodeType !== Node.ELEMENT_NODE) {
            continue;
        }

        const child = node as Element;
        const children = (value[child.tagName] ?? []) as unknown[];
        children.push(elementToValue(child));
        value[child.tagName] = children;
    }

    if (Object.keys(value).length === 0) {
        return text;
    }

    if (text !== "") {
        value._ = text;
    }

    return value;
};

export const parseXml = (xml: string): Record<string, unknown> => {
    const document = new DOMParser().parseFromString(xml, "application/xml");
    const parserError = document.querySelector("parsererror");

    if (parserError) {
        const detail = parserError.textContent?.replace(/\s+/g, " ").trim();
        throw new Error(`Unable to parse XML${detail ? `: ${detail}` : "."}`);
    }

    const root = document.documentElement;
    if (!root) {
        throw new Error("Unable to parse XML: no root element was found.");
    }

    return { [root.tagName]: elementToValue(root) };
};
